<siq-dropdown-menu
  [tree]="tree"
  [hideCaret]="true"
  rootLabel="Reports"
  [notifyCount]="notifyCount"
></siq-dropdown-menu>
